export default "__VITE_ASSET__xd4mnw4b__"